//App-wide tuning settings (ex src/app/data/Config.ts — call sites still
//import it as `Config`). Ease members read the gsap window shim at module
//init, which is safe: the CDN/Blade shim loads before the bundle.
//NOTE on the device import: utils/device imports this module back. The cycle
//is safe because neither side reads the other's bindings during module
//evaluation (device is only referenced inside getCurrentMobileSwitch, and
//device.ts only reads Config inside its isSmallDevice getter).
import { device } from 'utils/device';

export default {
	//Layout-width threshold: below this the app switches to its mobile
	//layout/tuning (the classic `device.innerWidth < 800` checks). Distinct
	//from mobileWidth/topLevelMobileSwitch below, which gate other layouts.
	//CSS TWIN: sass/vars/_breakpoints.scss $bp-mobile-switch (800px) — the
	//stylesheet's mobile/desktop switch. Change both together.
	mobileBreakpoint: 800,

	//Shared ease tokens (were `gsap.Power0.easeNone` / `gsap.Power3.easeInOut`
	//literals at ~27 call sites):
	linearEase: gsap.Power0.easeNone,
	standardEase: gsap.Power3.easeInOut,

	toProjectContainerEase: gsap.Power2.easeInOut,
	toProjectEase: gsap.Power2.easeInOut,
	fromProjectEase: gsap.Power2.easeInOut,
	toProjectMultipler: 0.85,
	fromProjectMultipler: 0.85,
	toProjectTime: 1,
	fromProjectTime: 1,
	toProjectWhiteEase: gsap.Power2.easeInOut,
	toProjectWhiteEaseTime: 1,
	toProjectWhiteDelay: 0,
	toProjectSectionChangeDelay: 0,

	//Floating element
	toFloatingElementEase: gsap.Power2.easeInOut,
	toFloatingElementBaseTime: 1,
	fromFloatingElementEase: gsap.Power2.easeInOut,

	fromFloatingElementBaseTime: 1,

	//Work Effects
	minBlackoutAlpha: 0.4,

	//Case Study Exit transition

	fromProjectWhiteEase: gsap.Power2.easeOut,
	fromProjectWhiteEaseTime: 1,
	fromProjectWhiteDelay: 0,

	exitProjectScrollTimeBase: 0.7,
	exitProjectScrollTimePerPx: 0.000009,
	exitScrollEase: gsap.Power2.easeInOut,
	exitProjectScrollMuiltplier: 0.75,

	exitProjectScrollSectionChangeDelay: 0.7,
	exitMaskTime: 1,
	exitMaskEase: gsap.Power2.easeInOut,
	exitMaskSectionChangeDelay: 0.05,

	//Home > WOrk
	toWorkEase: gsap.Power2.easeInOut,
	toWorkTime: 1.2,
	workScreensGridAlpha: 0.5,
	workScreensGridAlphaOnWork: 0.07,
	spacesParticleAlpha: 0.5,

	//Debugging
	allowMouse: true,
	allowTouch: false,

	//Mobile layout portrait + less than this width:
	mobileWidth: 750,
	topLevelMobileSwitch: 1000,
	topLevelMobileSwitchPortrait: 1100,

	getCurrentMobileSwitch() {
		return device.innerWidth > device.innerHeight
			? this.topLevelMobileSwitch
			: this.topLevelMobileSwitchPortrait;
	},

	//Square project header at this < with
	squareProjectHeaderWidth: 500,

	doProjectsButtonMouseOver: false,
	doInfoButtonMouseOver: false
};
